export const SUGGESTION_INSERT = 'suggestionInsert';
export const SUGGESTION_DELETE = 'suggestionDelete';

export const collectSuggestionRanges = (doc) => {
  const ranges = [];
  if (!doc || typeof doc.descendants !== 'function') {
    return ranges;
  }
  doc.descendants((node, pos) => {
    if (!node.isText) {
      return;
    }
    const mark = (node.marks || []).find(
      (item) =>
        item.type?.name === SUGGESTION_INSERT ||
        item.type?.name === SUGGESTION_DELETE
    );
    if (!mark) {
      return;
    }
    const type = mark.type.name;
    const last = ranges[ranges.length - 1];
    const to = pos + node.nodeSize;
    if (last && last.type === type && last.to === pos) {
      last.to = to;
      last.text += node.text || '';
      return;
    }
    ranges.push({
      type,
      from: pos,
      to,
      text: node.text || '',
    });
  });
  return ranges;
};

export const suggestionAt = (doc, pos) =>
  collectSuggestionRanges(doc).find((range) => pos >= range.from && pos <= range.to) ||
  null;

export const applySuggestionDecision = (tr, schema, range, accept) => {
  const markType = schema?.marks?.[range.type];
  if (!markType || range.from >= range.to) {
    return tr;
  }
  const keepText = accept === (range.type === SUGGESTION_INSERT);
  if (keepText) {
    tr.removeMark(range.from, range.to, markType);
  } else {
    tr.delete(range.from, range.to);
  }
  return tr;
};

export const applyAllSuggestions = (tr, schema, accept) => {
  const ranges = collectSuggestionRanges(tr.doc);
  for (let index = ranges.length - 1; index >= 0; index -= 1) {
    applySuggestionDecision(tr, schema, ranges[index], accept);
  }
  return tr;
};
